/**
 * Created by hejikun on 2017/10/30 0030.
 */
import { Base64 } from 'js-base64'
let authinfo = localStorage.getItem('authtoken')
let wechatId
let userId
let userDetail
let isWx
let isTx
let from
let noNeedLead
let alipay_user_id
let token
let allowAdv = true
let allowThirdSite = true
let allowOnlineAsk = true
let newAttention = false
let openMinappPay = false
let allowUserWrite = true
let useNewPay = false
let isMy = false
let isH5 = false
let mini_openid
if (authinfo) {
  token = JSON.parse(authinfo).data
  from = sessionStorage.getItem('fromCsfw')
  let isThird = from && from !== 'dytminiapp'
  if (sessionStorage.getItem('fromCsfw') === 'dytminapp') {
    from = ''
  }
  if (sessionStorage.getItem('fromCsfw') === 'dytminapp' && localStorage.getItem('dzjkk')) {
    from = 'dytminiapp'
  }
  wechatId = JSON.parse(Base64.decode(authinfo.split('.')[1])).wechat_id
  userId = JSON.parse(Base64.decode(authinfo.split('.')[1])).user_id
  mini_openid = JSON.parse(Base64.decode(authinfo.split('.')[1])).mini_openid
  alipay_user_id = JSON.parse(Base64.decode(authinfo.split('.')[1])).alipay_user_id
  userDetail = JSON.parse(Base64.decode(authinfo.split('.')[1]))
  isWx = localStorage.getItem('is_wx')
  isTx = sessionStorage.getItem('ThRegisterId')
  // let noNeedLead = sessionStorage.getItem('fromCsfw') === 'dytminiapp' || sessionStorage.getItem('fromCsfw') === 'tx' ? 1 : 0
  noNeedLead = sessionStorage.getItem('fromCsfw') === 'tx' ? 1 : 0

  if ((sessionStorage.getItem('fromCsfw') && sessionStorage.getItem('fromCsfw') !== 'dytminiapp') || isTx) {
    allowAdv = false
  }

  if (sessionStorage.getItem('fromCsfw') === 'dytminiapp' || sessionStorage.getItem('fromCsfw') === 'tx' || isTx) {
    allowThirdSite = false
  }

  // sessionStorage.getItem('fromCsfw') === 'dytminiapp'
  if (sessionStorage.getItem('fromCsfw') === 'tx' || isTx) {
    allowOnlineAsk = false
  }

  if (localStorage.getItem('channel') == 2) {
    useNewPay = true
  }

  if (!isThird && !noNeedLead && !userDetail.new_subscribe) {
    newAttention = false
  }

  if (sessionStorage.getItem('fromCsfw') === 'dytminiapp') {
    openMinappPay = true
  }

  // sessionStorage.getItem('fromCsfw') === 'dytminiapp' ||
  if (sessionStorage.getItem('fromCsfw') === 'tx') {
    allowUserWrite = false
  }
}
if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
  newAttention = false
  isMy = true
}
if (
  navigator.userAgent.indexOf('MicroMessenger') < 0 &&
  (navigator.userAgent.indexOf('Alipay') < 0 || navigator.userAgent.indexOf('AlipayClient') < 0)
) {
  newAttention = false
  isH5 = true
}
export default {
  imgBaseSrc: document.location.protocol + '//img.ynhdkc.com',
  isTest: /(testapp|ttestapp|localhost|test|192\.168|refactor-test)/.test(window.location.hostname),
  canTest: /(appv3-pre-production)/.test(window.location.hostname),
  wechatId,
  userId,
  userDetail,
  from,
  isWx,
  noNeedLead,
  token,
  allowAdv,
  allowThirdSite,
  allowOnlineAsk,
  useNewPay,
  newAttention,
  isMy,
  allowUserWrite,
  isTx,
  openMinappPay,
  mini_openid,
  alipay_user_id,
  isH5
}
